import { render, staticRenderFns } from "./OfficeTour.vue?vue&type=template&id=804b6dda&"
import script from "./OfficeTour.vue?vue&type=script&lang=js&"
export * from "./OfficeTour.vue?vue&type=script&lang=js&"
import style0 from "./OfficeTour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports